export default __webpack_public_path__ + "images/db906230aa412f012ac57185f5ab3844-convention.jpg";